// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoadingOverlay from "./features/ui/LoadingOverlay";
import HomePage from "./pages/HomePage.jsx";
import AssignmentPage from "./pages/AssignmentPage.jsx";
import PreviewPage from "./pages/PreviewPage.jsx";
import ReviewPage from "./pages/ReviewPage.jsx";

function App() {
  return (
    <Router>
      <LoadingOverlay>
        <Routes>
          <Route path="/home" element={<HomePage />} />
          <Route path="/assignment" element={<AssignmentPage />} />
          <Route path="/preview" element={<PreviewPage />} />
          <Route path="/review" element={<ReviewPage />} />
        </Routes>
      </LoadingOverlay>
    </Router>
  );
}

export default App;
